import { trans } from "@resources/localization"
import Table, { ColumnsType } from "antd/lib/table"
import React from "react"
import { useAppSelector } from "@hook/useAppSelector"

export const TableError: React.FC = () => {
    const dataResponseImport = useAppSelector((state) => state.deliveryCase.dataResponseImport)

    const columns: ColumnsType<any> = [
        {
            title: trans("order_list.lbc_import_line"),
            className: "bold-400",
            dataIndex: "line",
            width: 100,
        },
        {
            title: trans("delivery_case.status_error"),
            className: "bold-400",
            dataIndex: "success",
            render: (isStatus: boolean) => {
                return isStatus ? trans("delivery_case.status_success") : trans("delivery_case.status_fail")
            },
        },
        {
            title: trans("order_list.lbc_import_error"),
            className: "bold-400",
            render: (row) => {
                return row?.message || ""
            },
        },
    ]
    return (
        <div>
            {dataResponseImport?.successCount && dataResponseImport?.successCount > 0 ? (
                <p>{`${trans("contact.noti_succ")} ${dataResponseImport?.successCount} ${trans("delivery_case.status_import")}`}</p>
            ) : (
                ""
            )}
            <Table
                columns={columns}
                dataSource={dataResponseImport?.errors || []}
                pagination={false}
                scroll={{ y: 600 }}
            />
        </div>
    )
}
